import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "../lib/cart";
import { useContent } from "../context/ContentContext";

export const Nav = () => {
  const { count } = useCart();
  const { p } = useContent();
  const c = p("nav");
  const links = c.links.items || [];
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#F9F8F6]/90 border-b border-[#E4E1DB]" data-testid="main-nav">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="flex items-center justify-between h-20">
          <Link to="/" className="flex flex-col leading-none" data-testid="nav-logo">
            <span className="font-display text-2xl tracking-tight">{c.brand.name}</span>
            <span className="overline text-[0.6rem] mt-1">{c.brand.tagline}</span>
          </Link>

          <nav className="hidden lg:flex items-center gap-7">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} data-testid={`nav-${l.to.slice(1)}`}
                className={({ isActive }) =>
                  `text-[0.8rem] tracking-wide link-underline transition-colors ${isActive ? "text-[#B35D4B]" : "text-[#1C1B1A] hover:text-[#B35D4B]"}`}>
                {l.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-4">
            <Link to="/cart" className="relative" data-testid="nav-cart">
              <ShoppingBag className="w-5 h-5" strokeWidth={1.5} />
              {count > 0 && (
                <span className="absolute -top-2 -right-2 bg-[#B35D4B] text-white text-[0.6rem] w-4 h-4 flex items-center justify-center rounded-full" data-testid="cart-count">
                  {count}
                </span>
              )}
            </Link>
            <button className="lg:hidden" onClick={() => setOpen(!open)} data-testid="nav-menu-toggle" aria-label="Menu">
              {open ? <X className="w-6 h-6" strokeWidth={1.5} /> : <Menu className="w-6 h-6" strokeWidth={1.5} />}
            </button>
          </div>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E4E1DB] bg-[#F9F8F6]" data-testid="mobile-menu">
          <nav className="flex flex-col px-5 py-4">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} data-testid={`mobile-nav-${l.to.slice(1)}`}
                className="py-3 text-sm border-b border-[#E4E1DB] last:border-0">
                {l.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};
